export default __webpack_public_path__ + "0601dcf4ff299fe16a0af1e945ea518a.png";